var colorwayCache = window.colowayCache || {};
if (!customElements.get("color-ways")) {
  customElements.define(
    "color-ways",
    class Colorways extends HTMLElement {
      constructor() {
        super();
        this.tag = this.getAttribute("tag");
        this.sort = this.getAttribute("sort") || "price-descending";
        this.view = this.getAttribute("view") || "colorways";
        this.currentColorway = this.getAttribute("current-colorway") || null;
        this.cachedUrls = new Set();
        this.cachedOptions = [];
        // window.colorwayCache = {};
      }

      async connectedCallback() {
        if (!this.tag) return;
        let colorDesc = ``
        if(this.currentColorway) {
          colorDesc = `<div style="margin-bottom: .5rem;">COLOR: <span id="displayed-color">${this.currentColorway}</span></div>`
        }
        this.innerHTML = `${colorDesc}<div class="colorways__container"><p>Loading...</p></div>`;
        await this.fetchAndRender();
        this.cacheAllProductPages();
        window.replaceContentWithCache = this.swapToProduct.bind(this);
        window.cacheHoveredLink = this.cacheProductPage.bind(this);
        window.cacheAllProductPages = this.cacheAllProductPages.bind(this);
        window.swatchHover = this.swatchHover.bind(this);
        window.swatchLeave = this.swatchLeave.bind(this);
        this.initVariantListener();
        this.applyOptionValuesOnLoad();
      }

      applyOptionValuesOnLoad() {
        const params = new URLSearchParams(window.location.search);
        const optionValues = params.get("option_values");
        if (!optionValues) return;

        const values = optionValues
          .split(",")
          .map((v) => v.trim().toLowerCase());

        const groups = this.querySelectorAll("variant-selects fieldset");

        groups.forEach((fieldset, i) => {
          const radios = fieldset.querySelectorAll('input[type="radio"]');
          const valueToSelect = values[i];
          if (!valueToSelect) return;

          radios.forEach((radio) => {
            const label = fieldset.querySelector(`label[for="${radio.id}"]`);
            const labelText = label?.dataset?.realName.trim().toLowerCase();
            const radioValue = radio.value.trim().toLowerCase();

            if (labelText === valueToSelect || radioValue === valueToSelect) {
              radio.checked = true;
              radio.dispatchEvent(new Event("change", { bubbles: true }));
            }
          });
        });
      }

      initVariantListener() {
        this.variantUnsubscribe = subscribe(
          PUB_SUB_EVENTS.variantChange,
          ({ data }) => {
            this.cachedOptions = data.variant.options;
            for(const alt_product_link of document.querySelectorAll('.alt-product-options')) {
              const base = alt_product_link.href.split('?')[0]
              alt_product_link.href = `${base}?option_values=${this.cachedOptions.join(',')}`
            }
            // console.log('cachedOptions',this.cachedOptions);
            const variant = data?.variant;
            if (!variant?.title) return;
            this.blurOosSizes(variant.title);
          }
        );
      }

      blurOosSizes(selectedSize) {
        const allLinks = this.querySelectorAll("a.colorway-link");
        allLinks.forEach((link) => {
          link.classList.remove("oos");
          const span = link.querySelector("span[data-oos-sizes]");
          if (!span) return;

          const oosSizes = span.getAttribute("data-oos-sizes").toLowerCase();
          if (oosSizes.includes(`|${selectedSize.toLowerCase()}|`)) {
            link.classList.add("oos");
          }
        });
      }

      async fetchAndRender() {
        try {
          const res = await fetch(
            `/collections/all/${this.tag}?sort_by=${this.sort}&view=${this.view}`
          );
          const html = await res.text();
          const container = this.querySelector(".colorways__container");
          if (container && html) {
            container.innerHTML = html;
          }
        } catch (err) {
          console.error("Failed to load colorways:", err);
          this.querySelector(".colorways__container").innerHTML =
            "<p>Failed to load colorways.</p>";
        }
      }

      addCollectionPath(url) {
        if(url.includes('collections/')) {
            return url
        }
        const match = window.location.pathname.match(/^\/collections\/([^/]+)/);
        let collectionHandle;
        if (match) {
          collectionHandle = match[1];
          // console.log(collectionHandle); // "new-arrivals-women"
        }
        if(collectionHandle) {
          return url.replace('/products/',`/collections/${collectionHandle}/products/`)
        }
      }
      async swapToProduct(productUrl,newColor=null) {
        if(newColor) {
          setTimeout(() => {
            const color = document.getElementById('displayed-color') 
            color.textContent = decodeURIComponent(newColor)
            this.colorway = decodeURIComponent(newColor)
          }, 10);
        }
        const productInfo = document.querySelector("product-info");
        if (!productInfo) return;
        //todo: scroll to top of page
        const link = productUrl
        productUrl += `?option_values=${this.cachedOptions.join(',')}`
        // console.log('adding cached options and navigating to',productUrl)
        const shouldFetchFullPage = productInfo.dataset.updateUrl === "true";
        let html
        if (window.colorwayCache[link]) {
          html = window.colorwayCache[link]
        } else {
          await this.cacheProductPage(null,link)
        }
        html = window.colorwayCache[link]
        productInfo.renderProductInfoFromElement({
          html,
          targetId: "SwatchTrigger",
          callback: shouldFetchFullPage
            ? productInfo.handleSwapProduct(productUrl, shouldFetchFullPage)
            : productInfo.handleUpdateProductInfo(productUrl),
        });
        // window.scrollTo({
        //   top: 0,
        //   behavior: 'smooth' 
        // });
        // productInfo.renderProductInfo({
        //   requestUrl: productInfo.buildRequestUrlWithParams(
        //     productUrl,
        //     [],
        //     shouldFetchFullPage
        //   ),
        //   targetId: "SwatchTrigger",
        //   callback: shouldFetchFullPage
        //     ? productInfo.handleSwapProduct(productUrl, shouldFetchFullPage)
        //     : productInfo.handleUpdateProductInfo(productUrl),
        // });
      }

      swatchHover(url,newColor) {
        const color = document.getElementById('displayed-color') 
        if(color) {
          // console.log('doing show color',color)
          color.textContent = decodeURIComponent(newColor)
        }
        const hoverImg = document.getElementById('hover-img')
        if(hoverImg) {
          hoverImg.src = url
          hoverImg.style.opacity = 1
          hoverImg.style.zIndex = 8
        } else {
          document.querySelector('media-gallery slider-component').insertAdjacentHTML('afterBegin',`<img style="width: 100%;position: absolute;inset: 0;opacity:1;z-index: 8;" id="hover-img" src="${url}">`)
        }
      }
      swatchLeave() {
        const color = document.getElementById('displayed-color') 
        if(color) {
          // console.log('doing hide color')
          color.textContent = decodeURIComponent(this.currentColorway);
        }
        const hoverImg = document.getElementById('hover-img')
        if(hoverImg) {
          hoverImg.style.opacity = 0
          hoverImg.style.zIndex = -1
        }
      }

      async originalCacheHoveredLink(link) {
        if(colorwayCache[link]) {
          return
        }
        const response = await fetch(link)
        const fullHTML = await response.text()
    
        const parser = new DOMParser();
        const parsedHTML = parser.parseFromString('', 'text/html');
        const newDocument = parsedHTML.implementation.createHTMLDocument('');
        newDocument.documentElement.innerHTML = fullHTML;
        const fetchedElement = newDocument.querySelector('[data-barba="container"]');
        colorwayCache[link] = fetchedElement
    
        return colorwayCache[link]
      }
      async cacheProductPage(e=null,url) {
        if (window.colorwayCache[url]) return;
        const response = await fetch(url)
        const responseText = await response.text()
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        window.colorwayCache[url] = html
        this.cachedUrls.add(url);
        return true
      }
      // cache all possible colorways on mobile.
      async cacheAllProductPages() {
        for(const h of document.querySelectorAll('.colorways__container [data-handle]')){
          const url = `/products/${h.dataset.handle}`
          // console.log(url)
          await this.cacheProductPage(null,url)
        }
        
      }

      disconnectedCallback() {
        this.variantUnsubscribe?.();
      }
    }
  );
}
